/* Build your set (sections/tbc-build-set.liquid).

   One product per step of a set from Theme settings > Bundles. Products come
   from /collections/<handle>?view=tbc-build (templates/collection.tbc-build.liquid),
   the active step first; the tiers from the same settings the store's
   automatic discount mirrors. The button adds the chosen variants as
   ordinary lines and the discount prices them in the cart.

   Picking updates the touched card, the step tabs and the summary in place,
   so focus stays where the shopper is; a step change moves focus to the
   step's heading and, on a phone, scrolls back up to the tabs. One status
   line speaks for every change. */

(function () {
  var page = document.querySelector('[data-tbc-build]');
  if (!page) return;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CURRENCY = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';
  var PAGE_SIZE = 24;
  var format = page.getAttribute('data-money-format');
  var grid = page.querySelector('[data-tbc-build-grid]');
  var stepsNav = page.querySelector('[data-tbc-build-steps]');
  var heading = page.querySelector('[data-tbc-build-heading]');
  var filtersNode = page.querySelector('[data-tbc-build-filters]');
  var moreNode = page.querySelector('[data-tbc-build-more]');
  var moreButton = page.querySelector('[data-tbc-build-more-button]');
  var showingNode = page.querySelector('[data-tbc-build-showing]');
  var live = page.querySelector('[data-tbc-build-live]');
  var summary = page.querySelector('[data-tbc-build-summary]');
  var toggle = page.querySelector('[data-tbc-build-toggle]');
  var toggleLabel = page.querySelector('[data-tbc-build-toggle-label]');
  var list = page.querySelector('[data-tbc-build-list]');
  var bar = page.querySelector('[data-tbc-build-bar]');
  var tierText = page.querySelector('[data-tbc-build-tier]');
  var nowNode = page.querySelector('[data-tbc-build-now]');
  var wasNode = page.querySelector('[data-tbc-build-was]');
  var saveNode = page.querySelector('[data-tbc-build-save]');
  var addButton = page.querySelector('[data-tbc-build-add]');
  var statusNode = page.querySelector('[data-tbc-build-status]');
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function text(key, values) {
    return String(page.getAttribute('data-' + key) || '').replace(/__(\w+)__/g, function (match, name) {
      var value = values && values[name.toLowerCase()];
      return value != null ? value : '';
    });
  }

  function el(tag, className, content) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (content != null) node.textContent = content;
    return node;
  }

  function say(message) {
    live.textContent = '';
    window.setTimeout(function () { live.textContent = message; }, 60);
  }

  var rules = [];
  try { rules = JSON.parse(page.querySelector('[data-tbc-build-rules]').textContent || '[]'); } catch (error) { rules = []; }
  var wanted = new URLSearchParams(window.location.search).get('set') || page.getAttribute('data-bundle');
  /* A tier that needs more pieces than there are steps can never be reached. */
  function tiersOf(item) {
    var count = ((item && item.steps) || []).length;
    return ((item && item.tiers) || [])
      .filter(function (tier) { return tier[0] >= 1 && tier[0] <= count && tier[1] > 0 && tier[1] < 100; })
      .sort(function (a, b) { return a[0] - b[0]; });
  }
  var usable = rules.filter(function (item) { return item.steps.length && tiersOf(item).length; });
  var set = usable.filter(function (item) { return String(item.n) === String(wanted); })[0] || usable[0];
  var steps = (set && set.steps) || [];
  var tiers = tiersOf(set);

  function tierLine(itemTiers) {
    return itemTiers.map(function (tier) { return text('tier', { pieces: tier[0], percent: tier[1] }); }).join(' · ');
  }

  /* A list on a label line that breaks between its parts, never inside one. */
  function parts(className, items) {
    var line = el('span', className);
    items.forEach(function (item, i) {
      line.appendChild(el('span', 'tbc-build__set-part', item + (i < items.length - 1 ? ' ·' : '')));
      if (i < items.length - 1) line.appendChild(document.createTextNode(' '));
    });
    return line;
  }

  /* One tab per set, each reloading this page with ?set=N: its name, its best
     tier and what it holds (the steps). The summary spells out the tiers, so
     with tabs the offer needs no line of its own. */
  var setsNav = page.querySelector('[data-tbc-build-sets]');
  var lead = page.querySelector('[data-tbc-build-lead]');
  if (usable.length > 1) {
    usable.forEach(function (item) {
      var itemTiers = tiersOf(item);
      var best = itemTiers[itemTiers.length - 1][1];
      var url = new URL(window.location.href);
      url.searchParams.set('set', item.n);
      var tab = el('a', 'tbc-build__set');
      tab.href = url.pathname + url.search;
      if (item === set) tab.setAttribute('aria-current', 'page');
      tab.appendChild(el('span', 'tbc-build__set-name', item.name));
      tab.appendChild(parts('tbc-build__set-contents', item.steps.map(function (step) { return step.title; })));
      tab.appendChild(el('span', 'tbc-build__set-offer', text(itemTiers.length > 1 ? 'set-up-to' : 'set-percent', { percent: best })));
      setsNav.appendChild(tab);
    });
    setsNav.hidden = false;
    lead.hidden = true;
  }

  if (!steps.length || !tiers.length) {
    grid.appendChild(el('p', 'tbc-build__note', text('unavailable')));
    summary.hidden = true;
    return;
  }

  /* Sets sold as one product ("Never a piece" in Theme settings > Bundles). */
  var excluded = (set.exclude || []).map(function (type) { return String(type).toLowerCase(); });
  var products = {};
  var loading = {};
  var choice = {};
  var filters = {};
  var shown = {};
  var cards = {};
  var active = 0;
  var busy = false;

  function money(cents) {
    var value = Math.round(cents) / 100;
    function fixed(decimals, thousands, decimal) {
      var parts = value.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
    }
    return String(format || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
      switch (key) {
        case 'amount_no_decimals': return fixed(0, ',', '.');
        case 'amount_with_comma_separator': return fixed(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fixed(0, '.', ',');
        case 'amount_with_apostrophe_separator': return fixed(2, "'", '.');
        case 'amount_with_space_separator': return fixed(2, ' ', ',');
        default: return fixed(2, ',', '.');
      }
    });
  }

  /* ---- data ---------------------------------------------------------------- */

  function fetchCollection(handle) {
    var key = 'tbc-build-v3:' + handle + ':' + CURRENCY;
    try {
      var cached = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (cached && Date.now() - cached.at < 15 * 60 * 1000) return Promise.resolve(cached.items);
    } catch (error) { /* storage unavailable */ }
    return fetch(ROOT + 'collections/' + handle + '?view=tbc-build&sort_by=best-selling')
      .then(function (response) { return response.ok ? response.text() : '[]'; })
      .then(function (body) {
        var items = JSON.parse(body || '[]');
        try { sessionStorage.setItem(key, JSON.stringify({ at: Date.now(), items: items })); } catch (error) { /* full */ }
        return items;
      })
      .catch(function () { return []; });
  }

  function loadStep(step) {
    if (products[step.id] || loading[step.id]) return loading[step.id] || Promise.resolve();
    loading[step.id] = Promise.all(step.collections.map(function (entry) { return fetchCollection(entry.handle); }))
      .then(function (lists) {
        var seen = {};
        products[step.id] = [].concat.apply([], lists).filter(function (product) {
          if (seen[product.handle]) return false;
          if (excluded.indexOf(String(product.type || '').toLowerCase()) !== -1) return false;
          if (!product.variants.some(function (variant) { return variant.available; })) return false;
          seen[product.handle] = true;
          return true;
        });
        if (steps[active] === step) {
          renderFilters();
          renderGrid();
        }
      });
    return loading[step.id];
  }

  function stepTitle(step, index) {
    return step.title || String(index + 1);
  }

  function chosenSteps() {
    return steps.filter(function (step) { return choice[step.id] && choice[step.id].variant; });
  }

  function percentFor(count) {
    var percent = 0;
    tiers.forEach(function (tier) { if (tier[0] <= count) percent = tier[1]; });
    return percent;
  }

  /* ---- filters: the closure and one option (weight, size) when they split the step */

  function norm(value) {
    return String(value).trim().toLowerCase();
  }

  function facetsFor(step) {
    var items = products[step.id] || [];
    var facets = [];
    var closures = {};
    items.forEach(function (product) { if (product.closure) closures[product.closure] = true; });
    var closureValues = Object.keys(closures);
    if (closureValues.length > 1 && closureValues.length <= 6) facets.push({ key: 'closure', label: text('closure'), values: closureValues });

    /* Values match without case ("14 oz", "14 Oz"); one-offs ("16 oz XL") stay out of the chips. */
    var byName = {};
    items.forEach(function (product) {
      (product.options || []).forEach(function (option) {
        var entry = byName[option.name] || (byName[option.name] = { count: 0, values: {} });
        entry.count += 1;
        option.values.forEach(function (value) {
          var key = norm(value);
          var seen = entry.values[key] || (entry.values[key] = { label: value, count: 0 });
          seen.count += 1;
        });
      });
    });
    Object.keys(byName)
      .filter(function (name) { return name !== 'Title' && byName[name].count >= items.length / 2; })
      .some(function (name) {
        var entry = byName[name];
        var values = Object.keys(entry.values).filter(function (key) { return entry.values[key].count > 1; });
        if (values.length < 2 || values.length > 8) return false;
        /* Weights sort by number; sizes keep the products' own order (Medium, Large, X-Large). */
        if (values.every(function (key) { return !isNaN(parseFloat(key)); })) {
          values.sort(function (a, b) { return parseFloat(a) - parseFloat(b); });
        }
        facets.push({ key: 'option:' + name, label: name, values: values, labels: values.map(function (key) { return entry.values[key].label; }) });
        return true;
      });
    return facets;
  }

  function matches(product, picked) {
    return Object.keys(picked).every(function (key) {
      var value = picked[key];
      if (!value) return true;
      if (key === 'closure') return product.closure === value;
      var name = key.slice(7);
      var index = (product.options || []).map(function (option) { return option.name; }).indexOf(name);
      if (index === -1) return false;
      return product.variants.some(function (variant) { return variant.available && norm(variant.options[index]) === value; });
    });
  }

  function visibleItems(step) {
    var picked = filters[step.id] || {};
    return (products[step.id] || []).filter(function (product) { return matches(product, picked); });
  }

  /* ---- rendering ------------------------------------------------------------ */

  function renderSteps() {
    var focusedIndex = Array.prototype.indexOf.call(stepsNav.children, document.activeElement);
    stepsNav.replaceChildren();
    steps.forEach(function (step, index) {
      var picked = choice[step.id];
      var button = el('button', 'tbc-build__step');
      button.type = 'button';
      if (index === active) button.setAttribute('aria-current', 'step');
      if (picked && picked.variant) button.classList.add('is-done');
      button.appendChild(el('span', 'tbc-build__step-name', (index + 1) + ' · ' + stepTitle(step, index)));
      button.appendChild(el('span', 'tbc-build__step-pick', picked && picked.variant ? picked.product.title : text('choose')));
      button.addEventListener('click', function () { setActive(index, { focus: true }); });
      stepsNav.appendChild(button);
    });
    if (focusedIndex !== -1 && stepsNav.children[focusedIndex]) stepsNav.children[focusedIndex].focus();
  }

  function renderHeading() {
    heading.textContent = text('step-heading', { n: active + 1, total: steps.length, title: stepTitle(steps[active], active) });
  }

  /* ---- dropdown chips: a name beside a chip that opens a list -------------- */

  var CHEVRON = '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="square" aria-hidden="true" focusable="false"><path d="M6 9l6 6 6-6"/></svg>';
  var TICK = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="square" aria-hidden="true" focusable="false"><path d="M4 12.5l5 5L20 6.5"/></svg>';
  /* One list for every chip, on the page itself: the cards are transformed and
     the phone's filter row scrolls, either would clip it. */
  var menu = el('div', 'tbc-build__menu');
  menu.id = 'TbcBuildMenu-' + Math.random().toString(36).slice(2, 8);
  menu.setAttribute('role', 'listbox');
  menu.hidden = true;
  page.appendChild(menu);
  var menuOwner = null;

  function placeMenu() {
    if (!menuOwner) return;
    if (!menuOwner.isConnected) return closeMenu(false);
    var rect = menuOwner.getBoundingClientRect();
    menu.style.minWidth = rect.width + 'px';
    var width = menu.offsetWidth;
    var height = menu.offsetHeight;
    var left = Math.min(rect.left, window.innerWidth - width - 8);
    var top = rect.bottom + 4;
    if (top + height > window.innerHeight - 8 && rect.top - height - 4 > 8) top = rect.top - height - 4;
    menu.style.left = Math.max(8, left) + 'px';
    menu.style.top = top + 'px';
  }

  function closeMenu(refocus) {
    if (!menuOwner) return;
    var owner = menuOwner;
    menuOwner = null;
    menu.hidden = true;
    menu.replaceChildren();
    owner.setAttribute('aria-expanded', 'false');
    if (refocus) owner.focus();
  }

  function menuItems() {
    return Array.prototype.slice.call(menu.querySelectorAll('[role="option"]:not([aria-disabled="true"])'));
  }

  function openMenu(button, options, choose, label) {
    if (menuOwner === button) return closeMenu(true);
    closeMenu(false);
    menuOwner = button;
    button.setAttribute('aria-expanded', 'true');
    menu.setAttribute('aria-label', label);
    options.forEach(function (option) {
      var item = el('div', 'tbc-build__menu-item');
      item.setAttribute('role', 'option');
      item.tabIndex = -1;
      item.setAttribute('aria-selected', option.selected ? 'true' : 'false');
      item.appendChild(el('span', '', option.label));
      if (option.disabled) {
        item.setAttribute('aria-disabled', 'true');
        if (option.spoken) item.setAttribute('aria-label', option.spoken);
      } else {
        item.addEventListener('click', function () {
          closeMenu(true);
          choose(option.value);
        });
      }
      if (option.selected) item.insertAdjacentHTML('beforeend', TICK);
      menu.appendChild(item);
    });
    menu.hidden = false;
    placeMenu();
    var items = menuItems();
    var start = menu.querySelector('[aria-selected="true"]:not([aria-disabled="true"])') || items[0];
    if (start) start.focus({ preventScroll: true });
  }

  menu.addEventListener('keydown', function (event) {
    var items = menuItems();
    var index = items.indexOf(document.activeElement);
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      var next = index + (event.key === 'ArrowDown' ? 1 : -1);
      if (items.length) items[(next + items.length) % items.length].focus();
    } else if (event.key === 'Home' || event.key === 'End') {
      event.preventDefault();
      if (items.length) items[event.key === 'Home' ? 0 : items.length - 1].focus();
    } else if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      if (index !== -1) items[index].click();
    } else if (event.key === 'Escape' || event.key === 'Tab') {
      event.preventDefault();
      closeMenu(true);
    }
  });

  document.addEventListener('pointerdown', function (event) {
    if (menuOwner && !menu.contains(event.target) && !menuOwner.contains(event.target)) closeMenu(false);
  });
  window.addEventListener('scroll', placeMenu, { passive: true });
  window.addEventListener('resize', placeMenu);

  /* name: shown beside the chip; face: the chip's text; options: [{value,
     label, selected, disabled, spoken}]; choose(value) runs on a pick. */
  function dropdown(config) {
    var field = el('div', 'tbc-build__dropdown-field' + (config.className ? ' ' + config.className : ''));
    field.appendChild(el('span', 'tbc-build__dropdown-label tbc-build__dropdown-name', config.name));
    var button = el('button', 'tbc-build__dropdown' + (config.active ? ' is-active' : ''));
    button.type = 'button';
    button.setAttribute('aria-haspopup', 'listbox');
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-controls', menu.id);
    button.setAttribute('aria-label', config.label + ': ' + config.face);
    button.appendChild(el('span', 'tbc-build__dropdown-face', config.face));
    button.insertAdjacentHTML('beforeend', CHEVRON);
    function open() { openMenu(button, config.options, config.choose, config.label); }
    button.addEventListener('click', open);
    button.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        if (menuOwner !== button) open();
      }
    });
    field.appendChild(button);
    return field;
  }

  function renderFilters() {
    var step = steps[active];
    var facets = facetsFor(step);
    filtersNode.replaceChildren();
    filtersNode.hidden = !facets.length;
    var picked = filters[step.id] || (filters[step.id] = {});
    facets.forEach(function (facet, facetIndex) {
      var value = picked[facet.key] || '';
      var index = facet.values.indexOf(value);
      filtersNode.appendChild(dropdown({
        name: facet.label,
        label: facet.label,
        face: index === -1 ? text('all') : (facet.labels ? facet.labels[index] : value),
        active: index !== -1,
        options: [''].concat(facet.values).map(function (option, i) {
          return { value: option, label: option ? (facet.labels ? facet.labels[i - 1] : option) : text('all'), selected: option === value };
        }),
        choose: function (option) {
          picked[facet.key] = option;
          shown[step.id] = PAGE_SIZE;
          renderFilters();
          renderGrid();
          var again = filtersNode.querySelectorAll('.tbc-build__dropdown')[facetIndex];
          if (again) again.focus();
          var count = visibleItems(step).length;
          say(text('showing', { shown: Math.min(count, shown[step.id]), total: count }));
        }
      }));
    });
  }

  /* The variant a card stands for until the shopper picks another: the first in stock. */
  function defaultVariant(product) {
    return product.variants.filter(function (variant) { return variant.available; })[0];
  }

  /* The card's options as buttons: every size or weight in view, sold out
     ones struck, and one tap picks the product with that option. The
     button of the variant in the set is pressed. */
  function sizeGroup(step, product, picked) {
    var name = (product.options && product.options[0] && product.options[0].name) || text('size');
    var box = el('div', 'tbc-build__sizes-box');
    box.appendChild(el('p', 'tbc-build__sizes-name', name));
    var sizes = el('div', 'tbc-build__sizes');
    sizes.setAttribute('role', 'group');
    sizes.setAttribute('aria-label', name + ', ' + product.title);
    product.variants.forEach(function (variant) {
      var chip = el('button', 'tbc-build__size' + (variant.available ? '' : ' is-out'), variant.title);
      chip.type = 'button';
      chip.setAttribute('data-variant', variant.id);
      if (!variant.available) {
        chip.setAttribute('aria-disabled', 'true');
        chip.setAttribute('aria-label', text('sold-out-value', { value: variant.title }));
      } else {
        chip.setAttribute('aria-pressed', picked && picked.variant && picked.variant.id === variant.id ? 'true' : 'false');
        chip.addEventListener('click', function () { pick(step, product, variant, null); });
      }
      sizes.appendChild(chip);
    });
    box.appendChild(sizes);
    return box;
  }

  /* The store's product card (snippets/product-grid-item.liquid): same
     classes, so it looks and moves the same. The photo is the button; a
     picked card gets the tick in its corner; its option buttons sit below. */
  function buildCard(step, product) {
    var picked = choice[step.id] && choice[step.id].product.handle === product.handle ? choice[step.id] : null;
    var card = el('div', 'grid-item product-item product-item--left product-item--outer-text tbc-build__card' + (picked ? ' is-selected' : ''));
    var frame = el('div', 'product-item__image');
    var select = el('button', 'product-link tbc-build__pick');
    select.type = 'button';
    select.setAttribute('aria-pressed', picked && picked.variant ? 'true' : 'false');
    select.setAttribute('aria-label', product.title + ', ' + money(product.price));
    var bg = el('span', 'product-item__bg');
    if (product.image) {
      var figure = el('span', 'image-wrapper image-wrapper--cover');
      var img = el('img', 'fit-cover');
      img.src = product.image;
      if (product.image_large) img.srcset = product.image + ' 300w, ' + product.image_large + ' 600w';
      img.sizes = '(max-width: 989px) 50vw, 320px';
      img.width = 300;
      img.height = 300;
      img.alt = '';
      img.loading = 'lazy';
      img.decoding = 'async';
      figure.appendChild(img);
      bg.appendChild(figure);
    }
    select.appendChild(bg);
    var mark = el('span', 'tbc-build__mark');
    mark.setAttribute('aria-hidden', 'true');
    mark.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="square" focusable="false"><path d="M4 12.5l5 5L20 6.5"/></svg>';
    select.appendChild(mark);
    select.addEventListener('click', function () { pick(step, product, null, select); });
    frame.appendChild(select);
    card.appendChild(frame);

    /* Same split as the card's title: "Model - Variant" on two lines. */
    var title = String(product.title).replace(/ - |- | -/g, ' - ');
    var cut = title.indexOf(' - ');
    var info = el('div', 'product-item__info');
    var heading = el('p', 'product-item__title' + (cut > 0 ? ' product-item__title--split' : ''));
    if (cut > 0) {
      heading.appendChild(el('span', 'product-item__title-model', title.slice(0, cut)));
      heading.appendChild(el('span', 'product-item__title-variant', title.slice(cut + 3)));
    } else {
      heading.textContent = title;
    }
    info.appendChild(heading);
    var holder = el('div', 'product-item__price__holder');
    holder.appendChild(el('span', 'product-item__cutline', product.closure || ''));
    var priceBox = el('div', 'product-item__price');
    var price = el('span', 'price' + (product.compare > product.price ? ' sale' : ''));
    price.appendChild(el('span', 'new-price', money(product.price)));
    if (product.compare > product.price) price.appendChild(el('span', 'old-price', money(product.compare)));
    priceBox.appendChild(price);
    holder.appendChild(priceBox);
    info.appendChild(holder);
    var information = el('div', 'product-information');
    information.setAttribute('aria-hidden', 'true');
    information.appendChild(info);
    /* The text picks too, for the mouse; keyboards and screen readers use the photo's button. */
    information.addEventListener('click', function () { pick(step, product, null, select); });
    card.appendChild(information);

    if (product.variants.length > 1) card.appendChild(sizeGroup(step, product, picked));
    cards[product.handle] = card;
    return card;
  }

  function renderGrid() {
    var step = steps[active];
    cards = {};
    grid.replaceChildren();
    grid.setAttribute('aria-label', stepTitle(step, active));
    if (!products[step.id]) {
      grid.appendChild(el('p', 'tbc-build__note', text('loading')));
      moreNode.hidden = true;
      return;
    }
    var items = visibleItems(step);
    if (!items.length) {
      grid.appendChild(el('p', 'tbc-build__note', text('nothing')));
      moreNode.hidden = true;
      return;
    }
    var limit = shown[step.id] || (shown[step.id] = PAGE_SIZE);
    items.slice(0, limit).forEach(function (product) { grid.appendChild(buildCard(step, product)); });
    moreNode.hidden = items.length <= limit;
    showingNode.textContent = text('showing', { shown: Math.min(limit, items.length), total: items.length });
  }

  /* One card changes: its selected state and its size chips, nothing else. */
  function updateCard(step, handle) {
    var card = cards[handle];
    if (!card) return;
    var product = (products[step.id] || []).filter(function (item) { return item.handle === handle; })[0];
    var picked = choice[step.id] && choice[step.id].product.handle === handle ? choice[step.id] : null;
    card.classList.toggle('is-selected', Boolean(picked));
    card.querySelector('.tbc-build__pick').setAttribute('aria-pressed', picked ? 'true' : 'false');
    var box = card.querySelector('.tbc-build__sizes-box');
    if (!box || !product) return;
    var focusedVariant = box.contains(document.activeElement) && document.activeElement.getAttribute('data-variant');
    var fresh = sizeGroup(step, product, picked);
    box.replaceWith(fresh);
    var again = focusedVariant && fresh.querySelector('[data-variant="' + focusedVariant + '"]');
    if (again) again.focus({ preventScroll: true });
  }

  function renderSummary() {
    var focusedRemove = document.activeElement && document.activeElement.closest && document.activeElement.closest('.tbc-build__row');
    list.replaceChildren();
    steps.forEach(function (step, index) {
      var picked = choice[step.id];
      var row = el('li', 'tbc-build__row' + (picked ? '' : ' is-empty'));
      if (picked) {
        var thumb = el('span', 'tbc-build__thumb');
        if (picked.product.image) {
          var img = el('img');
          img.src = picked.product.image;
          img.alt = '';
          thumb.appendChild(img);
        }
        row.appendChild(thumb);
        var copy = el('span', 'tbc-build__row-copy');
        copy.appendChild(el('span', 'tbc-build__row-title', picked.product.title));
        if (picked.product.variants.length > 1 || picked.variant.title !== 'Default Title') {
          copy.appendChild(el('span', 'tbc-build__row-variant', picked.variant.title));
        }
        row.appendChild(copy);
        row.appendChild(el('span', 'tbc-build__row-price', money(picked.variant.price)));
        var remove = el('button', 'tbc-build__remove');
        remove.type = 'button';
        remove.setAttribute('aria-label', text('remove', { title: picked.product.title }));
        remove.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="square" aria-hidden="true" focusable="false"><path d="M6 6l12 12"/><path d="M18 6L6 18"/></svg>';
        remove.addEventListener('click', function () {
          var title = picked.product.title;
          var handle = picked.product.handle;
          delete choice[step.id];
          if (steps[active] === step) updateCard(step, handle);
          renderSummary();
          say(text('removed', { title: title }));
          setActive(index, { focus: true, scroll: true });
        });
        row.appendChild(remove);
      } else {
        row.appendChild(el('span', 'tbc-build__thumb tbc-build__thumb--empty'));
        row.appendChild(el('span', 'tbc-build__row-copy', text('empty-step', { step: stepTitle(step, index) })));
      }
      list.appendChild(row);
    });
    if (focusedRemove && !list.contains(document.activeElement)) heading.focus({ preventScroll: true });

    var chosen = chosenSteps();
    var count = chosen.length;
    var maxPieces = tiers[tiers.length - 1][0];
    var minPieces = tiers[0][0];
    bar.style.setProperty('--pieces', maxPieces);
    bar.replaceChildren();
    for (var i = 0; i < maxPieces; i++) bar.appendChild(el('span', i < count ? 'is-filled' : ''));

    var percent = percentFor(count);
    if (count < minPieces) {
      tierText.textContent = text('need-more', { count: minPieces - count, percent: tiers[0][1] });
    } else {
      var message = text('tier-now', { count: count, percent: percent });
      var nextPercent = percentFor(count + 1);
      if (nextPercent > percent && count < steps.length) message += ' ' + text('next', { percent: nextPercent });
      tierText.textContent = message;
    }

    var total = chosen.reduce(function (sum, step) { return sum + Number(choice[step.id].variant.price || 0); }, 0);
    var now = Math.round(total * (100 - percent) / 100);
    nowNode.textContent = money(now);
    wasNode.textContent = percent > 0 ? money(total) : '';
    saveNode.textContent = percent > 0 ? text('save', { amount: money(total - now) }) : '';
    addButton.disabled = busy || count < minPieces;
    toggleLabel.textContent = count === 1 ? text('pieces-one') : text('pieces-other', { count: count });
  }

  function setActive(index, options) {
    var opts = options || {};
    closeMenu(false);
    active = index;
    renderSteps();
    renderHeading();
    loadStep(steps[active]);
    renderFilters();
    renderGrid();
    if (opts.scroll) stepsNav.scrollIntoView({ block: 'start', behavior: reduceMotion ? 'auto' : 'smooth' });
    if (opts.focus) heading.focus({ preventScroll: true });
  }

  function pick(step, product, variant, origin) {
    var previous = choice[step.id];
    var same = previous && previous.product.handle === product.handle;
    /* A second tap on a chosen product, not on its option, lets it go. */
    if (!variant && same) {
      delete choice[step.id];
      updateCard(step, product.handle);
      renderSteps();
      renderSummary();
      say(text('removed', { title: product.title }));
      return;
    }
    var chosenVariant = variant || defaultVariant(product);
    choice[step.id] = { product: product, variant: chosenVariant };
    if (previous && !same) updateCard(step, previous.product.handle);
    updateCard(step, product.handle);
    renderSteps();
    renderSummary();
    say(text('picked', { title: product.title + (product.variants.length > 1 ? ', ' + chosenVariant.title : '') }));
    /* Changing the option of a chosen product stays on its card. */
    if (same) return;
    var index = steps.indexOf(step);
    var next = steps.findIndex(function (other, i) { return i > index && !(choice[other.id] && choice[other.id].variant); });
    if (next === -1) next = steps.findIndex(function (other) { return !(choice[other.id] && choice[other.id].variant); });
    if (next !== -1 && next !== index) setActive(next, { focus: true, scroll: true });
    else if (origin) origin.focus();
  }

  /* ---- actions -------------------------------------------------------------- */

  moreButton.addEventListener('click', function () {
    var step = steps[active];
    var before = shown[step.id] || PAGE_SIZE;
    shown[step.id] = before + PAGE_SIZE;
    renderGrid();
    var firstNew = grid.children[before] && grid.children[before].querySelector('.tbc-build__pick');
    if (firstNew) firstNew.focus();
  });

  toggle.addEventListener('click', function () {
    var open = toggle.getAttribute('aria-expanded') !== 'true';
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    summary.classList.toggle('is-open', open);
  });

  addButton.addEventListener('click', function () {
    var chosen = chosenSteps();
    if (busy || chosen.length < tiers[0][0]) return;
    busy = true;
    addButton.setAttribute('aria-busy', 'true');
    statusNode.textContent = text('adding');
    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: chosen.map(function (step) {
        var picked = choice[step.id];
        return { id: Number(picked.variant.id), quantity: 1, properties: picked.product.props || {} };
      }) })
    })
      .then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (body) {
          if (!response.ok) throw new Error(body.description || body.message || '');
        });
      })
      .then(function () {
        statusNode.textContent = text('added');
        var items = document.querySelector('cart-items');
        if (items && typeof items.getCart === 'function' && !(window.theme && window.theme.hasCartDrawer === false)) items.getCart();
        else window.location.href = ROOT + 'cart';
      })
      .catch(function (error) { statusNode.textContent = error.message || text('error'); })
      .then(function () {
        busy = false;
        addButton.removeAttribute('aria-busy');
        renderSummary();
      });
  });

  lead.textContent = tierLine(tiers);

  setActive(0);
  renderSummary();
  /* The other steps load once the first has had its turn. */
  loadStep(steps[0]).then(function () {
    steps.slice(1).forEach(function (step) { loadStep(step); });
  });
})();
